<template>
	<div class="blocks-sidebar">
		<div class="pa-3 pb-1">
			<p class="subtitle-2 mb-0">Blocchi</p>
			<p class="caption grey--text">Trascina nell'editor</p>
		</div>

		<v-expansion-panels v-model="openPanels" multiple flat accordion>
			<!-- Modelli: la struttura di una mail tipo, si applica con un clic (non si trascina) -->
			<v-expansion-panel>
				<v-expansion-panel-header class="py-2 px-3">
					<div class="d-flex align-center">
						<v-icon small class="mr-2">mdi-view-dashboard-outline</v-icon>
						<span class="body-2 font-weight-medium">Modelli</span>
					</div>
				</v-expansion-panel-header>
				<v-expansion-panel-content>
					<div class="blocks-grid">
						<div v-for="model in models" :key="model.key"
							class="block-item" :title="model.description + ' — fai clic per partire da qui'"
							@click="$emit('model', model.key)">
							<div class="block-item__tile">
								<v-icon>{{ model.icon }}</v-icon>
							</div>
							<span class="block-item__label">{{ model.label }}</span>
						</div>
					</div>
				</v-expansion-panel-content>
			</v-expansion-panel>

			<v-expansion-panel v-for="(cat, ci) in categories" :key="ci">
				<v-expansion-panel-header class="py-2 px-3">
					<div class="d-flex align-center">
						<v-icon small class="mr-2">{{ cat.icon }}</v-icon>
						<span class="body-2 font-weight-medium">{{ cat.name }}</span>
					</div>
				</v-expansion-panel-header>
				<v-expansion-panel-content>
					<draggable
						:list="cat.blocks"
						:group="{ name: 'blocks', pull: 'clone', put: false }"
						:clone="cloneBlock"
						:sort="false"
						class="blocks-grid">
						<div v-for="block in cat.blocks" :key="block.type"
							class="block-item" :title="block.description + ' — trascina, oppure fai clic per aggiungerlo'"
							@click="$emit('add', block.type)">
							<div class="block-item__tile">
								<v-icon>{{ block.icon }}</v-icon>
							</div>
							<span class="block-item__label">{{ block.label }}</span>
						</div>
					</draggable>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>
	</div>
</template>

<script>
import draggable from 'vuedraggable'
import { blockCategories, createBlock } from './emailBlocks'
import { emailModels } from './emailModels'

export default {
	name: 'blocks-sidebar',

	components: { draggable },

	data() {
		return {
			// I blocchi `hidden` restano nel catalogo per i template salvati ma non si offrono piu'
			categories: blockCategories.map(function(cat) {
				return Object.assign({}, cat, { blocks: cat.blocks.filter(function(b) { return !b.hidden }) })
			}),
			models: emailModels,
			openPanels: [0, 1, 2, 3]
		}
	},

	methods: {
		cloneBlock(blockDef) {
			return createBlock(blockDef.type)
		}
	}
}
</script>

<style scoped>
.blocks-sidebar {
	height: 100%;
	overflow-y: auto;
	background: #fff;
}

.blocks-grid {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 6px;
	padding: 0 12px 12px;
}

/* Riquadro con la sola icona; l'etichetta sta fuori, nera e leggibile */
.block-item {
	display: flex;
	flex-direction: column;
	align-items: center;
	cursor: grab;
	margin-bottom: 4px;
}

.block-item__tile {
	width: 100%;
	height: 50px;
	border: 1px solid #cfcfcf;
	border-radius: 6px;
	background: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.15s;
}

.block-item__tile .v-icon {
	color: #424242;
}

.block-item__label {
	margin-top: 6px;
	font-size: 13px;
	line-height: 1.2;
	font-weight: 500;
	color: #212121;
	text-align: center;
}

.block-item:hover .block-item__tile {
	border-color: var(--v-primary-base, #1976d2);
	background: #f5f9ff;
}

.block-item:hover .block-item__tile .v-icon {
	color: var(--v-primary-base, #1976d2);
}

.block-item:active {
	cursor: grabbing;
}

.v-expansion-panel-content >>> .v-expansion-panel-content__wrap {
	padding: 0;
}

.v-expansion-panel-header {
	min-height: 40px !important;
}
</style>
